<template>
  <div>
    <table>
        <tbody>
            <tr v-for="session in sortedPastSessions" :key="session.id">
                <td>{{ session.dt | toDate }}</td>
                <td>{{session.name}}</td>
                <td><a class="secondary-content" :class="(session.status == 'Missed') ? 'red-text' : ''"><i class="material-icons">{{session.status | statusIconify}}</i></a></td>
                <td><router-link :to="{ name: 'Session', params: { session: session, isPastSession: true, user: user }}" class="secondary-content"><i
                            class="material-icons">subdirectory_arrow_right</i></router-link></td>
            </tr>
        </tbody>
    </table>
  </div>
</template>

<script>
import api from '@/api'
import moment from 'moment'
export default {
  name: 'pastSessionList',
  props: {
    'user': Object
  },
  data: function () {
    return {
      pastSessions: []
    }
  },
  created () {
    this.getPastSessions().then((sessions) => { this.pastSessions = sessions })
  },
  computed: {
    // sort the next session by descending time
    sortedPastSessions () {
      return this.pastSessions.sort((a, b) => moment(b.dt) - moment(a.dt))
    }
  },
  methods: {
    getPastSessions () {
      return api.getPastSessions(this.user).then((sessions) => { return Object.values(sessions) })
    }
  },
  filters: {
    statusIconify (val) {
      switch (val) {
        case 'Completed':
          return 'done'
        case 'Missed':
          return 'call_missed'
      }
    },
    toDate (val) {
      return moment(val).format('ll')
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/components/sessions/PastSessionList.vue